import React from 'react';
import { motion } from 'framer-motion';

interface PhoneFrameProps {
  children: React.ReactNode;
}

export const PhoneFrame: React.FC<PhoneFrameProps> = ({ children }) => {
  return (
    <motion.div
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="phone-frame"
    >
      <div className="phone-screen">
        {/* Phone Notch */}
        <div className="phone-notch"></div>
        
        {/* Status Bar */}
        <div className="absolute top-2 left-4 right-4 flex justify-between items-center text-black text-sm font-medium z-20">
          <span>11:23</span>
          <div className="flex items-center space-x-1">
            <div className="w-4 h-2 bg-black rounded-sm"></div>
            <div className="w-4 h-2 bg-black rounded-sm"></div>
            <div className="w-6 h-3 border border-black rounded-sm"></div>
          </div>
        </div>

        {/* Content */}
        <div className="pt-8 h-full">
          {children}
        </div>
      </div>
    </motion.div>
  );
};
